import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
                51cg吃瓜网
              </h4>
              <p className="text-sm text-background-300 leading-relaxed">
                国内领先的娱乐八卦与热点资讯聚合平台。吃瓜第一线，真相不缺席。关注51cg，不错过每一个精彩瞬间。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                热门分类
              </h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    用户协议
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-background-300 mb-3">
                微信：51cg_chigua
              </p>
              <p className="text-sm text-background-300 mb-3">
                微博：@51cg吃瓜网
              </p>
              <p className="text-sm text-background-300">
                邮箱：contact@51cg.fun
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2024 51cg吃瓜网 51cg.fun - 版权所有
            </p>
            <p className="text-xs text-background-400">
              51cg吃瓜网 | 51cg.fun黑料吃瓜网 | 51cg莫里秀
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}